/*
 * banner-image-atc.js
 *
 * Adds the selected product variant to the cart and opens the cart drawer
 * when a banner button has been configured with action = "add_to_cart".
 *
 * Markup contract (set by section-banner-image.liquid):
 *   <a data-banner-atc data-variant-id="{id}" data-quantity="1" ...>
 */
(function () {
  'use strict';

  const SELECTOR = '[data-banner-atc]';
  const inflight = new Set();

  function openCartDrawer() {
    const toggle = document.querySelector('[data-cart-drawer-toggle][aria-controls="cart-drawer"]');
    const drawer = document.querySelector('#cart-drawer, [data-cart-drawer]');
    const isOpen = drawer && (drawer.classList.contains('is-open') || drawer.classList.contains('drawer--is-open'));

    if (toggle && !isOpen) {
      toggle.click();
      return;
    }

    document.dispatchEvent(new CustomEvent('theme:cart:toggle', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  }

  function setLoading(btn, loading) {
    if (!btn) return;
    btn.classList.toggle('is-loading', loading);
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loading) {
      btn.dataset.originalLabel = btn.dataset.originalLabel || btn.textContent.trim();
    } else if (btn.dataset.originalLabel) {
      btn.textContent = btn.dataset.originalLabel;
      delete btn.dataset.originalLabel;
    }
  }

  async function addToCart(variantId, quantity, sellingPlan) {
    const body = {
      items: [{
        id: parseInt(variantId, 10),
        quantity: parseInt(quantity, 10) || 1
      }]
    };
    if (sellingPlan) body.items[0].selling_plan = parseInt(sellingPlan, 10);

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Add to cart failed');
    }
    return res.json();
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest(SELECTOR);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      console.warn('[banner-image-atc] Missing data-variant-id on', btn);
      return;
    }

    const key = btn.dataset.bannerAtcKey || `${variantId}:${btn.dataset.quantity || 1}`;
    if (inflight.has(key)) return;
    inflight.add(key);

    setLoading(btn, true);

    try {
      const data = await addToCart(
        variantId,
        btn.getAttribute('data-quantity') || 1,
        btn.getAttribute('data-selling-plan')
      );

      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true, detail: data }));

      openCartDrawer();
    } catch (err) {
      console.error('[banner-image-atc]', err);
      btn.classList.add('has-error');
      setTimeout(() => btn.classList.remove('has-error'), 1800);
    } finally {
      inflight.delete(key);
      setLoading(btn, false);
    }
  }, { passive: false });
})();
